import { useEffect, useMemo, useState } from 'react';

import type { MatchesCalendarOptions } from '../store/types';
import { MatchesCalendarMode } from '../store/types';

export const useMatchesCalendarMenu = (options: MatchesCalendarOptions) => {
  const defaultMode = useMemo(() => {
    if (options.disableRouting) return MatchesCalendarMode.ROUNDS;
    if (options.useBracketView) return MatchesCalendarMode.BRACKET;

    return null;
  }, [options.disableRouting, options.useBracketView]);

  const [mode, setMode] = useState<MatchesCalendarMode>(defaultMode);

  useEffect(() => {
    const menu = document.querySelector<HTMLPkSegmentedControlElement>('.matches-calendar__tabs pk-segmented-control');
    if (!menu) return;

    const onMenuChange = (e: CustomEvent<{ value: string }>) => {
      const value = e.detail.value;
      setMode(value === 'bracket' ? MatchesCalendarMode.BRACKET : MatchesCalendarMode.DATES);
      window.scrollTo({ top: 0, behavior: 'instant' });
    };

    menu.addEventListener('pkChange', onMenuChange);

    return () => {
      menu.removeEventListener('pkChange', onMenuChange);
    };
  }, [options.disableRouting]);

  return mode;
};
